import { styled } from 'styled-components'

export const Title = styled.h3`
	font-size: ${({ theme }) => theme.font.size.s115};
	margin-top: 0;
	margin-bottom: 6px;
`
